(function () {
  if (window.GSCartWishlistDrawersReady) return;
  window.GSCartWishlistDrawersReady = true;

  var WISHLIST_KEY = 'gs_wishlist_items';
  var LEGACY_KEYS = [
    'wishlist',
    'gsWishlist',
    'gs_wishlist',
    'gse_wishlist',
    'theme_wishlist',
    'shopify_wishlist'
  ];

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function money(cents) {
    cents = Number(cents || 0);
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (error) {
      return '£' + (cents / 100).toFixed(2);
    }
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        "'": '&#39;',
        '"': '&quot;'
      }[char];
    });
  }

  function parseStored(value) {
    if (!value) return [];

    try {
      var parsed = JSON.parse(value);

      if (Array.isArray(parsed)) return parsed;
      if (parsed && Array.isArray(parsed.items)) return parsed.items;
      if (parsed && Array.isArray(parsed.products)) return parsed.products;
    } catch (error) {
      return String(value)
        .split(',')
        .map(function (item) {
          return item.trim();
        })
        .filter(Boolean);
    }

    return [];
  }

  function normalizeItem(item) {
    if (item === null || item === undefined) return null;

    if (typeof item === 'string' || typeof item === 'number') {
      var value = String(item).trim();
      if (!value) return null;

      if (/^\d+$/.test(value)) {
        return {
          id: value,
          key: value
        };
      }

      return {
        handle: value,
        key: value
      };
    }

    if (typeof item === 'object') {
      var handle = String(item.handle || item.product_handle || item.productHandle || '').trim();
      var id = String(item.id || item.product_id || item.productId || '').trim();
      var key = handle || id;

      if (!key) return null;

      return {
        key: key,
        id: id,
        handle: handle,
        title: item.title || item.product_title || item.productTitle || '',
        url: item.url || (handle ? '/products/' + handle : ''),
        image: item.image || item.featured_image || item.featuredImage || '',
        price: item.price || item.price_text || item.priceText || '',
        priceCents: item.priceCents || item.price_cents || item.price_min || item.priceMin || '',
        variantId: item.variantId || item.variant_id || '',
        variantTitle: item.variantTitle || item.variant_title || ''
      };
    }

    return null;
  }

  function uniqueItems(items) {
    var seen = {};
    var output = [];

    (items || []).forEach(function (item) {
      var normalized = normalizeItem(item);

      if (!normalized || !normalized.key || seen[normalized.key]) return;

      seen[normalized.key] = true;
      output.push(normalized);
    });

    return output;
  }

  function getWishlist() {
    var primary = localStorage.getItem(WISHLIST_KEY);

    if (primary) {
      return uniqueItems(parseStored(primary));
    }

    for (var i = 0; i < LEGACY_KEYS.length; i += 1) {
      var legacy = localStorage.getItem(LEGACY_KEYS[i]);

      if (legacy) {
        return uniqueItems(parseStored(legacy));
      }
    }

    return [];
  }

  function saveWishlist(items, options) {
    var cleanItems = uniqueItems(items);

    localStorage.setItem(WISHLIST_KEY, JSON.stringify(cleanItems));
    updateWishlistCount(cleanItems);
    updateWishlistButtons(cleanItems);
    renderWishlistDrawer(cleanItems);
    renderWishlistPage(cleanItems);

    document.dispatchEvent(
      new CustomEvent('wishlist:updated', {
        detail: {
          items: cleanItems,
          count: cleanItems.length
        }
      })
    );

    if (options && options.open) {
      openDrawer('wishlist');
    }

    return cleanItems;
  }

  function collectProductData(trigger) {
    var source =
      trigger.closest(
        '[data-wishlist-toggle], [data-gse-wishlist-toggle], [data-product-id], [data-product-handle], .card-wrapper, .product-card-wrapper, .card'
      ) || trigger;

    var dataset = source.dataset || {};
    var productLink = source.querySelector && source.querySelector('a[href*="/products/"]');
    var productImage = source.querySelector && source.querySelector('img');
    var productTitle =
      source.querySelector &&
      source.querySelector('.card__heading a, .card-information__text, .full-unstyled-link, .product-card-title, h3 a, h2 a');
    var productPrice = source.querySelector && source.querySelector('.price, .price-item, [data-product-price]');

    var url = dataset.productUrl || dataset.url || (productLink ? productLink.getAttribute('href') : '');
    var handle = dataset.productHandle || dataset.handle || '';

    if (!handle && url && url.indexOf('/products/') !== -1) {
      handle = url
        .split('/products/')[1]
        .split('?')[0]
        .split('#')[0]
        .replace(/\/$/, '');
    }

    if (!url && handle) {
      url = '/products/' + handle;
    }

    return normalizeItem({
      id: dataset.productId || dataset.id || '',
      handle: handle,
      title: dataset.productTitle || dataset.title || (productTitle ? productTitle.textContent.trim() : ''),
      url: url,
      image: dataset.productImage || dataset.image || (productImage ? productImage.currentSrc || productImage.src : ''),
      price: dataset.productPrice || dataset.price || (productPrice ? productPrice.textContent.trim().replace(/\s+/g, ' ') : ''),
      variantId: dataset.variantId || '',
      variantTitle: dataset.variantTitle || ''
    });
  }

  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);

    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin'
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (product) {
        if (!product) return null;

        return normalizeItem({
          id: product.id,
          handle: product.handle,
          title: product.title,
          url: product.url || '/products/' + product.handle,
          image: product.featured_image || (product.images && product.images[0]) || '',
          price: money(product.price_min || product.price || 0),
          priceCents: product.price_min || product.price || 0
        });
      })
      .catch(function () {
        return null;
      });
  }

  function hydrateWishlist(items) {
    var cleanItems = uniqueItems(items || getWishlist());

    return Promise.all(
      cleanItems.map(function (item) {
        if (item.title && item.image && item.price) {
          return Promise.resolve(item);
        }

        if (!item.handle) {
          return Promise.resolve(item);
        }

        return fetchProduct(item.handle).then(function (fetchedItem) {
          return fetchedItem ? Object.assign({}, item, fetchedItem) : item;
        });
      })
    ).then(function (hydratedItems) {
      var cleanHydratedItems = uniqueItems(hydratedItems);
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(cleanHydratedItems));
      return cleanHydratedItems;
    });
  }

  function updateWishlistCount(items) {
    var count = uniqueItems(items || getWishlist()).length;

    qsa('[data-gs-wishlist-count], [data-wishlist-count]').forEach(function (element) {
      element.textContent = count;
    });

    qsa('[data-gs-wishlist-count-label], [data-wishlist-count-label]').forEach(function (element) {
      element.textContent = count + (count === 1 ? ' item in wishlist' : ' items in wishlist');
    });

    qsa('[data-gs-wishlist-count-bubble], [data-wishlist-count-bubble]').forEach(function (bubble) {
      if (count > 0) {
        bubble.removeAttribute('hidden');
      } else {
        bubble.setAttribute('hidden', 'hidden');
      }
    });
  }

  function updateWishlistButtons(items) {
    var keys = uniqueItems(items || getWishlist()).map(function (item) {
      return item.key;
    });

    qsa('[data-wishlist-toggle], [data-gse-wishlist-toggle]').forEach(function (button) {
      var item = collectProductData(button);
      if (!item) return;

      var active = keys.indexOf(item.key) !== -1;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function openDrawer(type) {
    closeDrawers(false);

    var drawer = qs(type === 'cart' ? '[data-gs-cart-drawer]' : '[data-gs-wishlist-drawer]');
    if (!drawer) return;

    drawer.classList.add('is-active');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('gs-drawer-open');

    var panel = qs('.gs-side-drawer__panel', drawer);
    if (panel) {
      setTimeout(function () {
        panel.focus();
      }, 50);
    }
  }

  function closeDrawers(removeBodyClass) {
    qsa('.gs-side-drawer.is-active').forEach(function (drawer) {
      drawer.classList.remove('is-active');
      drawer.setAttribute('aria-hidden', 'true');
    });

    if (removeBodyClass !== false) {
      document.body.classList.remove('gs-drawer-open');
    }
  }

  function updateCartCount(count) {
    count = Number(count || 0);

    qsa('[data-gs-cart-count]').forEach(function (element) {
      element.textContent = count > 0 ? count : '';
    });

    qsa('[data-gs-cart-count-bubble], #cart-icon-bubble .cart-count-bubble').forEach(function (bubble) {
      if (count > 0) {
        bubble.removeAttribute('hidden');
      } else {
        bubble.setAttribute('hidden', 'hidden');
      }

      if (!bubble.querySelector('[data-gs-cart-count]')) {
        bubble.textContent = count > 0 ? count : '';
      }
    });
  }

  function closeIcon() {
    return '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none"><path d="M18 6 6 18M6 6l12 12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  }

  function sizedImageUrl(url, width) {
    if (!url) return '';
    if (url.indexOf('width=') !== -1) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function updateCartQuantity(key, quantity, options) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: Math.max(0, Number(quantity) || 0)
      })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        renderCart(cart, options || { open: true });
        return cart;
      });
  }

  function renderCart(cart, options) {
    var body = qs('[data-gs-cart-body]');
    var footer = qs('[data-gs-cart-footer]');
    var subtotal = qs('[data-gs-cart-subtotal]');

    if (!body) return;

    updateCartCount(cart.item_count || 0);

    if (subtotal) {
      subtotal.textContent = money(cart.total_price || 0);
    }

    if (!cart.items || !cart.items.length) {
      body.innerHTML =
        '<div class="gs-side-drawer__empty">' +
        '<h3>Your cart is empty</h3>' +
        '<p>Add your favourite products to your cart.</p>' +
        '<a class="button" href="/collections/all">Continue shopping</a>' +
        '</div>';

      if (footer) footer.hidden = true;
      if (options && options.open) openDrawer('cart');
      return;
    }

    body.innerHTML =
      '<div class="gs-side-drawer__items">' +
      cart.items
        .map(function (item) {
          var image = item.image || '';
          var title = item.product_title || item.title || '';
          var url = item.url || '#';
          var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';

          return (
            '<article class="gs-side-drawer__item">' +
            '<a class="gs-side-drawer__item-image-wrap" href="' +
            escapeHtml(url) +
            '">' +
            (image
              ? '<img class="gs-side-drawer__item-image" src="' +
                escapeHtml(sizedImageUrl(image, 220)) +
                '" alt="' +
                escapeHtml(title) +
                '" loading="lazy">'
              : '') +
            '</a>' +
            '<div class="gs-side-drawer__item-info">' +
            '<a class="gs-side-drawer__item-title" href="' +
            escapeHtml(url) +
            '">' +
            escapeHtml(title) +
            '</a>' +
            (variant ? '<p class="gs-side-drawer__item-meta">' + escapeHtml(variant) + '</p>' : '') +
            '<div class="gs-side-drawer__qty" data-gs-cart-qty-wrap>' +
            '<button class="gs-side-drawer__qty-btn" type="button" data-gs-cart-qty-minus data-gs-cart-key="' +
            escapeHtml(item.key) +
            '" aria-label="Decrease quantity">' +
            '<span aria-hidden="true">−</span>' +
            '</button>' +
            '<input class="gs-side-drawer__qty-input" type="number" min="0" step="1" value="' +
            escapeHtml(item.quantity) +
            '" data-gs-cart-qty-input data-gs-cart-key="' +
            escapeHtml(item.key) +
            '" aria-label="Quantity for ' +
            escapeHtml(title) +
            '">' +
            '<button class="gs-side-drawer__qty-btn" type="button" data-gs-cart-qty-plus data-gs-cart-key="' +
            escapeHtml(item.key) +
            '" aria-label="Increase quantity">' +
            '<span aria-hidden="true">+</span>' +
            '</button>' +
            '</div>' +
            '<p class="gs-side-drawer__item-price">' +
            money(item.final_line_price || item.line_price || 0) +
            '</p>' +
            '</div>' +
            '<button class="gs-side-drawer__item-remove" type="button" data-gs-cart-remove="' +
            escapeHtml(item.key) +
            '" aria-label="Remove ' +
            escapeHtml(title) +
            '">' +
            closeIcon() +
            '</button>' +
            '</article>'
          );
        })
        .join('') +
      '</div>';

    if (footer) footer.hidden = false;
    if (options && options.open) openDrawer('cart');
  }

  function fetchCart(options) {
    return fetch('/cart.js', {
      credentials: 'same-origin'
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        renderCart(cart, options || {});
        return cart;
      });
  }

  function addToCart(form) {
    var button = form.querySelector('[type="submit"], button[name="add"]');
    var formData = new FormData(form);

    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok) throw json;
          return json;
        });
      })
      .then(function () {
        return fetchCart({ open: true });
      })
      .catch(function (error) {
        alert((error && (error.description || error.message)) || 'Unable to add this product to cart.');
      })
      .finally(function () {
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      });
  }

  function renderWishlistDrawer(items) {
    var body = qs('[data-gs-wishlist-body]');
    var footer = qs('[data-gs-wishlist-footer]');

    if (!body) return;

    hydrateWishlist(items || getWishlist()).then(function (cleanItems) {
      updateWishlistCount(cleanItems);

      if (!cleanItems.length) {
        body.innerHTML =
          '<div class="gs-side-drawer__empty">' +
          '<h3>Your wishlist is empty</h3>' +
          '<p>Add your favourite products and view them here anytime.</p>' +
          '<a class="button" href="/collections/all">Continue shopping</a>' +
          '</div>';

        if (footer) footer.hidden = true;
        return;
      }

      body.innerHTML =
        '<div class="gs-side-drawer__items">' +
        cleanItems
          .map(function (item) {
            var title = item.title || 'Wishlist product';
            var url = item.url || (item.handle ? '/products/' + item.handle : '#');
            var price = item.price || (item.priceCents ? money(item.priceCents) : '');

            return (
              '<article class="gs-side-drawer__item">' +
              '<a class="gs-side-drawer__item-image-wrap" href="' +
              escapeHtml(url) +
              '">' +
              (item.image
                ? '<img class="gs-side-drawer__item-image" src="' +
                  escapeHtml(sizedImageUrl(item.image, 220)) +
                  '" alt="' +
                  escapeHtml(title) +
                  '" loading="lazy">'
                : '') +
              '</a>' +
              '<div class="gs-side-drawer__item-info">' +
              '<a class="gs-side-drawer__item-title" href="' +
              escapeHtml(url) +
              '">' +
              escapeHtml(title) +
              '</a>' +
              (price ? '<p class="gs-side-drawer__item-price">' + escapeHtml(price) + '</p>' : '') +
              '<div class="gs-side-drawer__item-actions">' +
              '<a class="gs-side-drawer__mini-button" href="' +
              escapeHtml(url) +
              '">View product</a>' +
              (item.variantId
                ? '<button class="gs-side-drawer__mini-button" type="button" data-gs-wishlist-add-cart="' +
                  escapeHtml(item.variantId) +
                  '">Add to cart</button>'
                : '') +
              '</div>' +
              '</div>' +
              '<button class="gs-side-drawer__item-remove" type="button" data-gs-wishlist-remove="' +
              escapeHtml(item.key) +
              '" aria-label="Remove ' +
              escapeHtml(title) +
              '">' +
              closeIcon() +
              '</button>' +
              '</article>'
            );
          })
          .join('') +
        '</div>';

      if (footer) footer.hidden = false;
    });
  }

  function renderWishlistPage(items) {
    var grid = qs('[data-gs-wishlist-grid]');
    var empty = qs('[data-gs-wishlist-empty]');

    if (!grid) return;

    hydrateWishlist(items || getWishlist()).then(function (cleanItems) {
      updateWishlistCount(cleanItems);

      if (!cleanItems.length) {
        grid.innerHTML = '';
        if (empty) empty.hidden = false;
        return;
      }

      if (empty) empty.hidden = true;

      grid.innerHTML = cleanItems
        .map(function (item) {
          var title = item.title || 'Wishlist product';
          var url = item.url || (item.handle ? '/products/' + item.handle : '#');
          var price = item.price || (item.priceCents ? money(item.priceCents) : '');

          return (
            '<article class="gs-wishlist-card">' +
            '<a class="gs-wishlist-card__image-wrap" href="' +
            escapeHtml(url) +
            '">' +
            (item.image
              ? '<img class="gs-wishlist-card__image" src="' +
                escapeHtml(sizedImageUrl(item.image, 500)) +
                '" alt="' +
                escapeHtml(title) +
                '" loading="lazy">'
              : '') +
            '<button class="gs-wishlist-card__remove" type="button" data-gs-wishlist-remove="' +
            escapeHtml(item.key) +
            '" aria-label="Remove ' +
            escapeHtml(title) +
            '">' +
            closeIcon() +
            '</button>' +
            '</a>' +
            '<div class="gs-wishlist-card__info">' +
            '<a class="gs-wishlist-card__title" href="' +
            escapeHtml(url) +
            '">' +
            escapeHtml(title) +
            '</a>' +
            (price ? '<p class="gs-wishlist-card__price">' + escapeHtml(price) + '</p>' : '') +
            '<div class="gs-wishlist-card__actions">' +
            '<a class="gs-side-drawer__mini-button" href="' +
            escapeHtml(url) +
            '">View product</a>' +
            (item.variantId
              ? '<button class="gs-side-drawer__mini-button" type="button" data-gs-wishlist-add-cart="' +
                escapeHtml(item.variantId) +
                '">Add to cart</button>'
              : '') +
            '</div>' +
            '</div>' +
            '</article>'
          );
        })
        .join('');
    });
  }

  function removeWishlistItem(key, openAfterRemove) {
    saveWishlist(
      getWishlist().filter(function (item) {
        return item.key !== key;
      }),
      { open: openAfterRemove }
    );
  }

  window.GSWishlist = window.GSWishlist || {
    get: getWishlist,
    count: function () {
      return getWishlist().length;
    },
    add: function (item, options) {
      var normalized = normalizeItem(item);
      if (!normalized) return getWishlist();

      var items = getWishlist().filter(function (existing) {
        return existing.key !== normalized.key;
      });

      items.push(normalized);
      return saveWishlist(items, options || { open: true });
    },
    remove: function (key) {
      removeWishlistItem(String(key), false);
      return getWishlist();
    },
    toggle: function (item, options) {
      var normalized = normalizeItem(item);
      if (!normalized) return getWishlist();

      var items = getWishlist();
      var exists = items.some(function (existing) {
        return existing.key === normalized.key;
      });

      items = exists
        ? items.filter(function (existing) {
            return existing.key !== normalized.key;
          })
        : items.concat([normalized]);

      return saveWishlist(items, options || { open: !exists });
    },
    refresh: function () {
      updateWishlistCount();
      updateWishlistButtons();
      renderWishlistDrawer();
      renderWishlistPage();
    },
    clear: function () {
      return saveWishlist([], {});
    }
  };

  window.gsWishlistToggle = function (trigger) {
    var item = typeof trigger === 'string' ? normalizeItem(trigger) : collectProductData(trigger);
    if (!item) return;

    window.GSWishlist.toggle(item, { open: true });
  };

  document.addEventListener('click', function (event) {
    var closeButton = event.target.closest('[data-gs-close-drawers]');
    if (closeButton) {
      event.preventDefault();
      closeDrawers();
      return;
    }

    var cartOpenButton = event.target.closest('[data-gs-open-cart]');
    if (cartOpenButton) {
      event.preventDefault();
      fetchCart({ open: true });
      return;
    }

    var wishlistOpenButton = event.target.closest('[data-gs-open-wishlist]');
    if (wishlistOpenButton) {
      event.preventDefault();
      renderWishlistDrawer();
      openDrawer('wishlist');
      return;
    }

    var wishlistToggle = event.target.closest('[data-wishlist-toggle], [data-gse-wishlist-toggle]');
    if (wishlistToggle) {
      var item = collectProductData(wishlistToggle);
      if (!item) return;

      event.preventDefault();
      window.GSWishlist.toggle(item, { open: true });
      return;
    }

    var wishlistRemove = event.target.closest('[data-gs-wishlist-remove]');
    if (wishlistRemove) {
      event.preventDefault();
      removeWishlistItem(wishlistRemove.getAttribute('data-gs-wishlist-remove'), true);
      return;
    }

    var cartRemove = event.target.closest('[data-gs-cart-remove]');
    if (cartRemove) {
      event.preventDefault();

      updateCartQuantity(cartRemove.getAttribute('data-gs-cart-remove'), 0, { open: true });
      return;
    }

    var qtyMinus = event.target.closest('[data-gs-cart-qty-minus]');
    var qtyPlus = event.target.closest('[data-gs-cart-qty-plus]');

    if (qtyMinus || qtyPlus) {
      event.preventDefault();

      var qtyButton = qtyMinus || qtyPlus;
      var key = qtyButton.getAttribute('data-gs-cart-key');
      var wrap = qtyButton.closest('[data-gs-cart-qty-wrap]');
      var input = wrap && wrap.querySelector('[data-gs-cart-qty-input]');

      if (!key || !input) return;

      var current = parseInt(input.value, 10) || 0;
      var next = qtyPlus ? current + 1 : Math.max(0, current - 1);

      updateCartQuantity(key, next, { open: true });
      return;
    }

    var wishlistAddCart = event.target.closest('[data-gs-wishlist-add-cart]');
    if (wishlistAddCart) {
      event.preventDefault();

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: wishlistAddCart.getAttribute('data-gs-wishlist-add-cart'),
          quantity: 1
        })
      })
        .then(function (response) {
          return response.json();
        })
        .then(function () {
          fetchCart({ open: true });
        });
    }
  });

  document.addEventListener(
    'change',
    function (event) {
      var input = event.target.closest('[data-gs-cart-qty-input]');
      if (!input) return;

      var key = input.getAttribute('data-gs-cart-key');
      if (!key) return;

      updateCartQuantity(key, input.value, { open: true });
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target.closest('form[action*="/cart/add"]');

      if (!form || form.hasAttribute('data-gs-cart-ignore') || form.closest('.gs-side-drawer')) {
        return;
      }

      // Capture-phase stop so Dawn product-form / quick-add do not also add.
      event.preventDefault();
      event.stopImmediatePropagation();
      addToCart(form);
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeDrawers();
    }
  });

  window.addEventListener('storage', function (event) {
    if (event.key === WISHLIST_KEY || LEGACY_KEYS.indexOf(event.key) !== -1) {
      window.GSWishlist.refresh();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    fetchCart({ open: false });
    window.GSWishlist.refresh();
  });
})();